import { UploadState } from './uploadTypings';

export const initialState: UploadState = {
  submittedFiles: [],
};
